export default {
  CONTACT_US: 'CONTACT_US',
  SCHOLARSHIP: 'SCHOLARSHIP',
  LEADS_CAPTURE: 'LEADS_CAPTURE',
};
